import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const toggleTab = () => {
  let container = document.querySelector(".gl__content");
  if (container) {
    let menuLinks = container.querySelectorAll(".content__menu a");
    let contentWrappers = container.querySelectorAll(".content__wrapper");
    if (menuLinks.length !== 0 && contentWrappers.length !== 0) {
      [...menuLinks].forEach(menuLink => {
        menuLink.addEventListener('click', (e) => {
          let menuId = menuLink.dataset.menu;
          let activeWrapper = container.querySelector(`.content__wrapper[data-menu="${menuId}"]`);
          e.preventDefault();
          [...menuLinks].forEach(menuLink => {
            menuLink.classList.remove('content__menu--active');
          });
          [...contentWrappers].forEach(contentWrapper => {
            contentWrapper.classList.remove('content__wrapper--active');
          });
          menuLink.classList.add('content__menu--active');
          activeWrapper.classList.add('content__wrapper--active');
        });
      });
    }
  }
}

export { toggleTab }
